import { render, staticRenderFns } from "./NotificationsDashboard.html?vue&type=template&id=84c6ceec&external"
import script from "./NotificationsDashboard.vue?vue&type=script&lang=js"
export * from "./NotificationsDashboard.vue?vue&type=script&lang=js"
import style0 from "./NotificationsDashboard.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports